import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

// Compact FAQ card for EV checkout (desktop + mobile). Hidden if the API returns nothing.
export default function CheckoutFaqs() {
  const [faqs, setFaqs] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await fetch(`${apiUrl}/api/faqs`, {
          headers: { "Content-Type": "application/json", Accept: "application/json" },
        });
        const data = await response.json();
        if (data.statusCode === "0100") setFaqs(data?.entities?.rows || []);
      } catch (error) {
        console.error("Error fetching faqs:", error);
      }
    };
    fetchFaqs();
  }, [apiUrl]);

  if (faqs.length === 0) return null;

  return (
    <div className="bg-white border border-[#f4efee] rounded-2xl p-4 md:p-6 flex flex-col gap-4 md:gap-5 w-full">
      <div className="flex items-center justify-between gap-2 w-full">
        <p className="text-[#1f2937] text-base font-semibold text-left">FAQs</p>
        {/* New tab: leaving checkout cancels the temporary booking */}
        <a href="/faq" target="_blank" rel="noopener noreferrer" className="text-[#5454d4] md:text-[#2563eb] text-[16px] md:text-sm font-semibold underline shrink-0">
          View All
        </a>
      </div>
      <div className="flex flex-col gap-3 w-full">
        {faqs.map((faq, index) => (
          <div key={faq.id} className="w-full border border-[#e7e7e7] rounded-xl overflow-hidden">
            <button
              type="button"
              className="w-full flex items-center justify-between px-4 py-2.5 text-left"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <span className="text-[#1f2937] text-[13px] md:text-sm font-medium leading-5 pr-4">{faq.headerText}</span>
              <motion.img
                src="/assets/mobile/faq/chevron.svg"
                alt=""
                width="24"
                height="24"
                className="shrink-0 size-6"
                animate={{ rotate: openIndex === index ? 270 : 90 }}
                transition={{ duration: 0.2 }}
              />
            </button>
            <AnimatePresence>
              {openIndex === index && faq.description && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.25, ease: "easeOut" }}
                  className="px-4 pb-3 text-[#6b7280] text-[12px] md:text-sm leading-relaxed text-left"
                >
                  {faq.description}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
}
